import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ThemePreference = 'system' | 'light' | 'dark';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private readonly storageKey = 'giantsms-theme';
  private preferenceSubject = new BehaviorSubject<ThemePreference>(this.readPreference());

  preference$ = this.preferenceSubject.asObservable();

  initialize() {
    this.applyPreference(this.preferenceSubject.value);
  }

  getPreference() {
    return this.preferenceSubject.value;
  }

  setPreference(preference: ThemePreference) {
    localStorage.setItem(this.storageKey, preference);
    this.preferenceSubject.next(preference);
    this.applyPreference(preference);
  }

  private readPreference(): ThemePreference {
    const preference = localStorage.getItem(this.storageKey);

    if (preference === 'light' || preference === 'dark' || preference === 'system') {
      return preference;
    }

    return 'system';
  }

  private applyPreference(preference: ThemePreference) {
    const root = document.documentElement;

    if (preference === 'system') {
      root.removeAttribute('data-theme');
      return;
    }

    root.setAttribute('data-theme', preference);
  }
}
